import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-135e6756")

_pushScopeId("data-v-135e6756")
const _hoisted_1 = { class: "container popup-container create-tag-page" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "create-tag-title" }
const _hoisted_4 = { class: "create-tag-name" }
const _hoisted_5 = { class: "create-tag-ations" }
const _hoisted_6 = { class: "create-tag-save" }
const _hoisted_7 = { class: "create-tag-close" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('title.create-new-tag')), 1),
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tagName = $event))
        }, null, 512), [
          [_vModelText, _ctx.tagName]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.create()))
          }, _toDisplayString(_ctx.$t('button.save')), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
          }, _toDisplayString(_ctx.$t('button.close')), 1)
        ])
      ])
    ])
  ]))
})